import React from 'react';
import './css/hero-types.css';

const taxes = [
	'Income tax (IT)',
	'Pay As You Earn (PAYE)',
	'Value Added Tax (VAT)',
	'Simplified Value Added Tax (SVAT) Scheme',
	'Social Security Contribution Levy (SSCL)',
	'Construction Industry Guarantee Fund Levy (CIGF)',
	'Capital Gain Tax (CGT)',
	'Stamp Duty (SD)',
	'Betting and Gaming Levy (B&GL)',
	'Economic Service Charge (ESC)',
	'Share Transaction Levy (STL)',
	'Tourist VAT Refund Scheme (TVRS)',
	'Nation Building Tax (NBT)',
];

function TaxList({ items }) {
	return (
		<ul className="list tax-grid">
			{items.map((item, index) => {
				const tickClassName = `home-tick${index === 0 ? '' : index}`;

				return (
					<li className="list-item" key={item}>
						<span className={tickClassName}>✔</span>
						<span>{item}</span>
					</li>
				);
			})}
		</ul>
	);
}

export default function HeroTypes() {
	return (
		<section className="home-banner">
			<div className="home-banner1 bannerContainer">
				<div className="home-container04">
					<h1 className="home-banner-heading">TYPES OF TAXES</h1>
					<div className="home-container05">
						<TaxList items={taxes} />
					</div>
				</div>
			</div>
		</section>
	);
}
